import { API_ENDPOINTS } from "@/configs";
import apiRequest from "@/lib/axios";
import { UserVipStanding, VipTier } from "@/types";

export const getVipTiers = async (): Promise<VipTier[]> => {
  return apiRequest({
    method: "GET",
    url: API_ENDPOINTS.VIP.LIST,
    errorMessage: "Failed to load VIP tiers",
  });
};

export const getMyVipStanding = async (): Promise<UserVipStanding> => {
  return apiRequest({
    method: "GET",
    url: API_ENDPOINTS.VIP.ME,
    errorMessage: "Failed to load your VIP standing",
  });
};
